import React, { Component } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { BrowserRouter, Route } from 'react-router-dom';
import { theme } from './theme';

import ScrollToTop from './components/utils/ScrollToTop';
import Home from './view/Home';
import AboutUs from './view/AboutUs';
import Portfolio from './view/Portfolio';
import Blog from './components/Blog';
import BlogPage from './components/BlogPage';

import AdminLogin from './components/admin/Login';
import Dashboard from './components/admin/Dashboard';
import ManageBlog from './components/admin/ManageBlog';
import BlogPost from './components/admin/BlogPost';
import UpdateBlog from './components/admin/UpdateBlog';
import ManageContact from './components/admin/ManageContact';

class App extends Component {
  render() {
    return (
      <div>
        <BrowserRouter>
          <ScrollToTop>
            <MuiThemeProvider theme={theme}>
              <Route path="/" component={Home} exact />
              <Route path="/about" component={AboutUs} exact />
              <Route path="/portfolio" component={Portfolio} exact />
              <Route path="/blog" component={Blog} exact />
              <Route path="/blogPage" component={BlogPage} exact />

              <Route path="/admin" component={AdminLogin} exact />
              <Route path="/admin/dashboard" component={Dashboard} exact />
              <Route path="/admin/manageBlog" component={ManageBlog} exact />
              <Route path="/admin/blogPost" component={BlogPost} exact />
              <Route path="/admin/updateBlog" component={UpdateBlog} exact />
              <Route path="/admin/manageContact" component={ManageContact} exact />
            </MuiThemeProvider>
          </ScrollToTop>
        </BrowserRouter>
      </div>
    );
  }
}

export default App;
